<div class="loginNewPage">

  <div class="loginLeft">
    <div class="logInParts">
      <div class="row sideLoginPart">
        <div class="col col-6 col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 title">
          <img class="logo" src="./assets/images/stag_logo.png" alt="logo">
        </div>
      </div>
      <div class="sideLoginPart margintop13px marginbottom13px">
        <div class="row full-width leftPanelTop card  p-3 mb-2 minht100per formDiv registerForm">
          <form novalidate (ngSubmit)="resetPassword(register.firstname)" method="post" id="login-form"
            class="form-group">
            <h1 class="form-header text-align-center text-color-white cursorArrow">{{ 'resetPassword' | translate }}</h1>
            <div height="16px" class="form-gap-div"></div>
            <div class="form-element">
              <div class="form-element-input">
                <input type="text" id="firstname" name="firstname" class="form-input-feild" value=""
                  [(ngModel)]="register.firstname" [placeholder]="'phYourUserName'| translate" required>
              </div>
            </div>
            <div class="form-element">
              <div class="col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12 pl-0 pr-0">
                <button type="submit" [ngClass]="{dis:register.firstname == '' ||register.firstname == undefined}"
                  (ngSubmit)="resetPassword(register.firstname)" id="login-form-submit" class="form-submit-button">
                  {{ 'resetPasswordLink' | translate }}
                </button>
              </div>
            </div>
            <div class="form-account text-color-white">
              <a (click)="backToLogin()" class="form-account-options">
                <<{{ 'backToLogin' | translate }}</a>
            </div>
            <div id="snackbar">
              <div class="text-message">
                {{toastMsg}}
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="sideLoginPart">
        <div class="login-footer">
          <a href="" class="form-account-options">
            {{ 'termsOfService' | translate }}
          </a>
          <span class="form-footer-dot">&nbsp;</span>
          <a href="" class="form-account-options">
            {{ 'privacyPolicy' | translate }}
          </a>
          <span class="form-footer-dot">&nbsp;</span>
          <a href="" class="form-account-options">
            {{ 'security' | translate }}
          </a>
        </div>
        <div class="row">
          <div class="col col-4 col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
          </div>
          <div class="col col-4 col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 text-align-center">
            <!-- <select #langSelect (change)="translate.use(langSelect.value);updateLanguage(langSelect.value)">
              <option *ngFor="let lang of languages" [value]="lang.short"
                [selected]="lang.short === translate.currentLang">
                {{ lang.fullform }}
              </option>
            </select> -->
          </div>
          <div class="col col-4 col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="loginSecondPart">
    <div class="logInParts">
      <div class="loginRightSide">
        <div class="centerImage">
          <img src="../assets/images/1.png">
        </div>
      </div>
    </div>
  </div>
</div>